import { SelectableCard } from './SelectableCard';
import { StepHeading } from './StepText';

export interface ProductCategoryOption {
    value: string;
    label: string;
}

interface Step4ProductCategoryProps {
    title: string;
    options: ProductCategoryOption[];
    value: string | null;
    onSelect: (value: string) => void;
}

export const Step4ProductCategory = ({
    title,
    options,
    value,
    onSelect,
}: Step4ProductCategoryProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <StepHeading>{title}</StepHeading>
            <ul className="flex flex-col gap-2">
                {options.map((option) => (
                    <li key={option.value}>
                        <SelectableCard
                            title={option.label}
                            selected={value === option.value}
                            onClick={() => onSelect(option.value)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
